import {
  UiZoneWidgetConfig,
  WidgetNames,
  WorkflowWidgetConfig,
  is2dArray,
  isNewWorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';
import { mapIframeWidgetFunction } from '../display-widgets/iframe.utils';
import { mapImageOrCarousalSectionsFunction } from '../display-widgets/image-carousal.utils';
import { mapLineWidgetFunction } from '../display-widgets/line.utils';
import { mapTextWidgetFunction } from '../display-widgets/text.utils';
import { mapBackButtonWidgetFunction } from '../widgets/back-button.utils';
import { mapProfileWidgetFunction } from '../widgets/profile.utils';
import { mapQuickLinksWidgetFunction } from '../widgets/quick-links.utils';

export const mapDefaultWidgetFunction = function mapDefaultWidget(
  item: WorkflowWidgetConfig,
): UiZoneWidgetConfig {
  const nestedWidgets = Object.fromEntries(
    Object.entries(item.widgetConfiguration?.nestedWidgets ?? {}).map(([key, value]) => {
      return [key, value.attributes];
    }),
  );
  return {
    nestedWidgets: nestedWidgets,
    attributes: item.widgetConfiguration?.attributes,
    name: item.name,
    gridPosition: item.gridPosition,
    uniqueId: item.uniqueId,
    childComponents:
      isNewWorkflowWidgetConfig(item) && item.childComponents
        ? mapChildComponents(item.childComponents)
        : undefined,
  } as UiZoneWidgetConfig;
};

function mapChildComponents(childComponents: any[][] | any[]): any[][] | any[] {
  if (is2dArray(childComponents)) {
    const list = childComponents as any[][];
    return list?.map((widgets) => {
      return widgets.map((widget) => {
        const mappingFunction = widgetToMappingFunctionMap.get(widget.name) ?? mapDefaultWidgetFunction;
        return mappingFunction(widget);
      });
    });
  }
  const list = childComponents as any[];
  return list?.map((widget) => {
    const mappingFunction = widgetToMappingFunctionMap.get(widget.name) ?? mapDefaultWidgetFunction;
    return mappingFunction(widget);
  });
}

export const widgetToMappingFunctionMap = new Map<
  string | undefined | null,
  (item: WorkflowWidgetConfig) => UiZoneWidgetConfig
>([
  [undefined, mapDefaultWidgetFunction],
  [null, mapDefaultWidgetFunction],
  ['', mapDefaultWidgetFunction],
  ['profile-page', mapProfileWidgetFunction],
  [WidgetNames.LINE_WIDGET, mapLineWidgetFunction],
  [WidgetNames.IFRAME_WIDGET, mapIframeWidgetFunction],
  [WidgetNames.TEXT_WIDGET, mapTextWidgetFunction],
  [WidgetNames.IMAGE_WIDGET, mapImageOrCarousalSectionsFunction],
  [WidgetNames.QUICK_LINKS_WIDGET, mapQuickLinksWidgetFunction],
  [WidgetNames.MULTI_ICON_QUICK_LINK_WIDGET, mapQuickLinksWidgetFunction],

  [WidgetNames.BACK_BUTTON_WIDGET, mapBackButtonWidgetFunction],
  // Onboarding widgets
  [WidgetNames.NAME_WIDGET, mapDefaultWidgetFunction],
  [WidgetNames.EMAIL_WIDGET, mapDefaultWidgetFunction],
  [WidgetNames.PHONE_WIDGET, mapDefaultWidgetFunction],
  [WidgetNames.BIRTHDAY_WIDGET, mapDefaultWidgetFunction],
  [WidgetNames.ADDRESS_WIDGET, mapDefaultWidgetFunction],
  [WidgetNames.FORM_ADDRESS_HISTORY_WIDGET, mapDefaultWidgetFunction],

  // Verification zone mostly
  [WidgetNames.CTA_BUTTON_WIDGET, mapDefaultWidgetFunction],
  [WidgetNames.SUMSUB_WIDGET, mapDefaultWidgetFunction],
  [WidgetNames.AIRWALLEX_RFI_WIDGET, mapDefaultWidgetFunction],
]);
